import type { RootState } from "../reducers/root.reducer"
import type { IRuntimeState } from "../types/state.types"

export const runtimeSelector = (state: RootState): IRuntimeState =>
    state.runtime
